import React, { ReactElement } from 'react';

import SheetContainer, {
    CloseButton,
    Content,
    Header,
    Heading,
    Overlay,
    Sheet,
} from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { Label } from '../../../../../../../common/labels/labelTypes';
import LabelColorPicker from '../components/LabelColorPicker';
import { Input } from '@milanote/roma';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import useLabelNameEditor from './useLabeSheetlNameEditor';

type LabelEditSheetProps = {
    label: Label;
    sheetProps: UseSheetReturnType;
};

const LabelEditSheet = (props: LabelEditSheetProps): ReactElement => {
    const { label, sheetProps } = props;

    const translate = useTranslator('popup', 'labels.edit');
    const { labelName, setLabelName, handleBlur, handleKeyDown } = useLabelNameEditor(label);

    return (
        <SheetContainer className="LabelEditSheet color-tool" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Header>
                    <Heading>{translate('heading')}</Heading>
                    <CloseButton />
                </Header>
                <Content className="px-3xl pt-lg">
                    <div className="pb-3xl flex flex-col gap-3xl">
                        <Input
                            size="lg"
                            value={labelName}
                            onChange={setLabelName}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                        />
                        <LabelColorPicker label={label} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default LabelEditSheet;
